import RPhoneInput, {
  Props as RPhoneInputProps,
} from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import { Box, FormHelperText, InputLabel } from '@mui/material';
import '../styles/PhoneInput.css';

export { isValidPhoneNumber, parsePhoneNumber } from 'react-phone-number-input';

type PhoneInputProps<T> = {
  value: string;
  onChange: RPhoneInputProps<T>['onChange'];
  label?: string;
  name?: string;
  required?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  helperText?: string;
  error?: boolean;
};

export default function PhoneInput<T>({
  value,
  onChange,
  onKeyDown,
  label,
  name,
  helperText,
  error,
  required,
}: PhoneInputProps<T>) {
  return (
    <Box className={error ? 'has-error' : ''}>
      {label && (
        <InputLabel error={error} sx={{ textAlign: 'left' }}>
          {label}
        </InputLabel>
      )}
      <RPhoneInput
        value={value}
        onChange={onChange}
        defaultCountry="TR"
        numberInputProps={{
          required,
          name,
          onKeyDown,
        }}
      />
      <FormHelperText title={helperText} error={error}>
        {helperText}
      </FormHelperText>
    </Box>
  );
}
